"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Vote = function (props) {
    var featureRequest = props.featureRequest;
    var renderUpvote = function () {
        return (preact_1.h("p", { className: "w-8 pt-1 pb-1 text-xs font-medium text-center text-gray-700 bg-white border border-gray-200 rounded" },
            preact_1.h("div", { className: "uparrow" }),
            preact_1.h("span", { id: "upvote_count" }, featureRequest.votes_count)));
    };
    var renderDownvote = function () {
        if (featureRequest.hasOwnProperty("downvotes_count")) {
            return (preact_1.h("p", { className: "w-8 pt-1 pb-1 mt-1 text-xs font-medium text-center text-gray-700 bg-white border border-gray-200 rounded" },
                preact_1.h("span", { id: "downvote_count" }, featureRequest.downvotes_count),
                preact_1.h("div", { className: "downarrow" })));
        }
    };
    return (preact_1.h("div", { className: "flex flex-col justify-start mr-2" },
        renderUpvote(),
        renderDownvote()));
};
exports.default = Vote;
